module.exports = __webpack_public_path__ + "static/media/DevelopKnowledgeTransfer.b1f62e12.mp4";